import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const tiaPoliciesTable = {
	selectAll: 'Označit vše',
	unselectAll: 'Odznačit vše',
};

const merge = {
	...tiaPoliciesTable,
};

export default Object.assign({}, merge, createLabeledMessages(merge));
